import { useState } from "react";
import Button from "../../common/button/button.component";
import { CalendarIcon, EnvelopIcon, GradCapIcon, HashtagIcon, LocationIcon, PeopleIcon, PrayingIcon, RingIcon, SuitCaseIcon } from "../../common/icons/icons";
import { Link } from "react-router-dom";

const StepTwo = () => {
    const [form, setForm] = useState([
        {
            name: "yyyy-mm-dd",
            value: "",
            icon: <CalendarIcon size={16} color={'white'} />,
        },
        {
            name: "Religion",
            value: "",
            icon: <PrayingIcon size={16} color={'white'} />,
        },
        {
            name: "Nationality",
            value: "",
            icon: <LocationIcon size={16} color={'white'} />,
        },
        {
            name: "School Branch",
            value: "",
            icon: <GradCapIcon size={16} color={'white'} />,
        },
        {
            name: "Department",
            value: "",
            icon: <PeopleIcon size={16} color={'white'} />,
        },
        {
            name: "Designation",
            value: "",
            icon: <SuitCaseIcon size={16} color={'white'} />,
        },
        {
            name: "Employment Stat",
            value: "",
            icon: <EnvelopIcon size={16} color={'white'} />,
        },
        {
            name: "Staff Number",
            value: "",
            icon: <HashtagIcon size={16} color={'white'} />,
        },
        {
            name: "Marital Status",
            value: "",
            icon: <RingIcon size={16} color={'white'} />
        },
    ])
    return (
        <>
            <div className="w-full h-full  " >
                <div className=" w-11/12  flex justify-center items-center flex-col md:w-1/2 lg:w-1/2   m-auto relative bg-white bg-opacity-50 rounded-xl pt-8 pb-3 "  >
                    <div className="w-full px-6" >
                        <h4 className=" text-center text-lg  md:text-xl lg:text-2xl text-white"  >Employee Sign Up</h4>
                        <p className=" text-base text-center md:text-lg lg:text-lg text-white" >We are almost done setting up your profile</p>
                    </div>
                    <div className=" flex px-4 items-center justify-between flex-wrap lg:px-16 mt-2" >
                        {form.map(({ name, icon }) => (
                            <div className=" w-46% flex items-center justify-between border-white border md:w-46% lg:w-46%  rounded-md p-3 mt-2 "  >
                                <div className=" w-1/6  items-center justify-center" >
                                    {icon}
                                </div>
                                <div className=" w-11/12 " >
                                    <input className="w-full outline-none text-white placeholder-white " style={{ background: "none" }} placeholder={name} />
                                </div>
                            </div>
                        ))}
                        <div className="w-full flex items-center justify-between mt-3 " >
                            <Button className=" w-2/5 bg-white cursor-pointer rounded-md p-2 flex border border-primary_color items-center justify-center mb-5 text-primary_color text-base md:text-lg lg:text-lg  font-semibold hover:bg-primary_color hover:text-white" btnTitle={'Done'} />
                            <Button className=" w-2/5 bg-white cursor-pointer rounded-md p-2 flex border border-primary_color items-center justify-center mb-5 text-primary_color text-base md:text-lg lg:text-lg  font-semibold hover:bg-primary_color hover:text-white" btnTitle={'Cancel'} />
                        </div>
                    </div>

                    <div className="text-center text-sm md:text-base lg:text-lg text-white mb-2 cursor-pointer"  >
                        <p>Step 2 of 2</p>
                    </div>
                    <div className="w-full flex items-center justify-center" >
                        <Link className="text-center text-sm md:text-base lg:text-lg text-white mb-5 cursor-pointer" to={'/login'} >Alread have an account? Sign In!</Link>
                    </div>
                </div>
            </div>
        </>
    );
}

export default StepTwo;